import React from 'react'
import { Route, Routes } from 'react-router-dom'
import HomePage from '../components/HomePage/HomePage'
import Cart from '../components/Cart/Cart';
import SingleProduct from '../components/Products/SingleProduct';
import SingleCategory from '../components/Categories/SingleCategory';
import Checkout from '../components/Checkout/Checkout';
import AdminPanel from '../components/AdminPanel/AdminPanel';
import SearchResults from '../components/Search/SearchResults';
import Favorites from '../components/Favorites/Favorites';
import UserOrders from '../components/UserOrders/UserOrders';
import NotFound from '../components/NotFound/NotFound';


const AppRoutes = () => (
    <Routes>
      <Route index path='/' element={<HomePage />} />
      <Route path='/favorites' element={<Favorites />} />
      <Route path='/orders' element={<UserOrders />} />
      <Route path='/products/:id' element={<SingleProduct />} /> 
      <Route path='/categories/:id' element={<SingleCategory />} /> 
      <Route path='/cart' element={<Cart />} />
      <Route path='/checkout' element={<Checkout />} />
      <Route path='/search' element={<SearchResults />} />
      <Route path='/admin' element={<AdminPanel />} />
      <Route path='*' element={<NotFound />} />
    </Routes>    
  )

export default AppRoutes;
